var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "mapDiv",
      staticStyle: { height: "100%", position: "relative" },
    },
    [
      _c("div", { staticClass: "map", attrs: { id: "map" } }),
      JSON.stringify(_vm.poisiton) !== "{}"
        ? _c("c-name", {
            staticClass: "detail",
            attrs: { param: _vm.poisiton },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }